var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { Savable } from '@/common/mixins/Savable';
import { Focusable } from '@/common/mixins/Focusable';
import { KeyedAttachmentsData } from '@/common/types/KeyedAttachmentsData';
import PlainTextControl from '@/common/components/PlainTextControl.vue';
import TextAreaControl from "@/common/components/TextAreaControl.vue";
import AttachmentWrapperTableCell from "@/common/components/AttachmentWrapperTableCell.vue";
import { createGuid } from "@/common/utils/idUtilities";
import { Notification } from '@/common/services/notificationService';
var AttachmentTable = /** @class */ (function (_super) {
    __extends(AttachmentTable, _super);
    function AttachmentTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kAttachmentsData = new KeyedAttachmentsData();
        _this.uploading = [];
        return _this;
    }
    AttachmentTable.prototype.mounted = function () {
        // Build the keyed attachment wrappers
        this.kAttachmentsData.kattachments = this.value
            .map(function (a) {
            return {
                key: createGuid(),
                attachment: a
            };
        });
        if (this.kAttachmentsData.kattachments.length == 0)
            this.addRow();
    };
    AttachmentTable.prototype.nameRequired = function (ka) {
        var _this = this;
        var _a;
        return (((_a = this.kAttachmentsData) === null || _a === void 0 ? void 0 : _a.kattachments.indexOf(ka)) == 0 && this.required && !this.kAttachmentsData.kattachments.some(function (x) { return _this.attachmentFilledAndValid(x.attachment); })) || (!!ka.attachment.blobUri && ka.attachment.blobUri.length > 0);
    };
    AttachmentTable.prototype.addRow = function () {
        return __awaiter(this, void 0, Promise, function () {
            var attachment, keyedAttachment, targetClass;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attachment = this.createNewAttachment();
                        keyedAttachment = {
                            key: createGuid(),
                            attachment: attachment
                        };
                        this.kAttachmentsData.kattachments.push(keyedAttachment);
                        this.$emit("input", this.kAttachmentsData.kattachments.map(function (a) { return a.attachment; }));
                        if (!(this.kAttachmentsData.kattachments.length > 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        targetClass = this.$attrs.id + "-" + this.kAttachmentsData.kattachments.length;
                        this.focusOnComponentClass(targetClass);
                        this.forceSave();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AttachmentTable.prototype.deleteRow = function (key) {
        if (confirm(this.$t("Confirmation.DeleteRow").toString())) {
            var index = this.kAttachmentsData.kattachments.findIndex(function (a) { return a.key == key; });
            this.kAttachmentsData.kattachments.splice(index, 1);
            this.$emit("input", this.kAttachmentsData.kattachments.map(function (a) { return a.attachment; }));
            this.forceSave();
        }
    };
    // attachment is required if required = true, it's the first row and there is no full attachment row given in attachments
    // attachment is also required if attachment name has input or attachment.displayKey exists.
    AttachmentTable.prototype.setRequired = function (ka) {
        var _this = this;
        ka.attachment.isRequired = (this.kAttachmentsData.kattachments.indexOf(ka) == 0 && this.required && !this.kAttachmentsData.kattachments.some(function (x) { return _this.attachmentFilledAndValid(x.attachment); })) || ((!!ka.attachment.name && ka.attachment.name.length > 0) || !!ka.attachment.displayKey);
    };
    Object.defineProperty(AttachmentTable.prototype, "showDelete", {
        get: function () {
            return this.kAttachmentsData.kattachments && this.kAttachmentsData.kattachments.length > 1;
        },
        enumerable: false,
        configurable: true
    });
    AttachmentTable.prototype.attachmentFilledAndValid = function (attachment) {
        return attachment.name && attachment.blobUri;
    };
    AttachmentTable.prototype.attachmentNameClass = function (name, index, id) {
        if (this.kAttachmentsData.isNameDuplicate(name)) {
            return [id + '-' + (index + 1), 'validation-error'];
        }
        return [id + '-' + (index + 1)];
    };
    AttachmentTable.prototype.startUpload = function (event, index) {
        this.touch();
        this.change();
        this.uploading.push(index);
    };
    AttachmentTable.prototype.stopUpload = function (event, index) {
        this.uploading.splice(this.uploading.indexOf(index), 1);
    };
    AttachmentTable.prototype.addedAttachment = function (event, attachment) {
        attachment.blobUri = event;
        this.blur();
        if (this.kAttachmentsData.isFileNameDuplicate(attachment.fileNameWithExtension)) {
            Notification.error(this, this.$t("Validation.DuplicateAttachmentFileName"));
        }
        else {
            Notification.success(this, this.$t("Attachment.Success"));
        }
    };
    AttachmentTable.prototype.deletedAttachment = function (event, attachment) {
        attachment.blobUri = null;
        this.forceSave();
    };
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], AttachmentTable.prototype, "value", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], AttachmentTable.prototype, "title", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AttachmentTable.prototype, "required", void 0);
    __decorate([
        Prop({ type: String, required: false, default: "Correspondence.Attachment.Placeholder" }),
        __metadata("design:type", String)
    ], AttachmentTable.prototype, "textPlaceholder", void 0);
    __decorate([
        Prop({ type: Number, required: false, default: 50 }),
        __metadata("design:type", Number)
    ], AttachmentTable.prototype, "attachmentNameMaxLength", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], AttachmentTable.prototype, "validateImmediately", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: true }),
        __metadata("design:type", Boolean)
    ], AttachmentTable.prototype, "showActions", void 0);
    __decorate([
        Prop({
            type: Function,
            required: false,
            default: function () {
                return { name: null, displayKey: null, isRequired: false, fileNameWithExtension: null, blobUri: null };
            }
        }),
        __metadata("design:type", Function)
    ], AttachmentTable.prototype, "createNewAttachment", void 0);
    __decorate([
        Prop({
            type: Function,
            required: false,
            default: function (attachment) { return !attachment.displayKey; }
        }),
        __metadata("design:type", Function)
    ], AttachmentTable.prototype, "allowDelete", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } }),
        __metadata("design:type", Array)
    ], AttachmentTable.prototype, "allowedExtensions", void 0);
    AttachmentTable = __decorate([
        Component({
            name: 'AttachmentTable',
            components: {
                AttachmentWrapperTableCell: AttachmentWrapperTableCell,
                TextAreaControl: TextAreaControl,
                PlainTextControl: PlainTextControl
            }
        })
    ], AttachmentTable);
    return AttachmentTable;
}(Mixins(Savable, Focusable)));
export default AttachmentTable;
